import LoginContainer from 'modules/accountManagement/containers/LoginContainer';

const LoginView = () => <LoginContainer />;

export default LoginView;
